import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Select,
  MenuItem,
  Box,
  Typography,
  Alert,
  FormControl,
  InputLabel,
  Container,
  Paper,
} from '@mui/material';
import { getBranches } from '../../axios';

const AddBatchForm = ({ editBatch, onSubmit }) => {
  const [admin, setAdmin] = useState('');
  const [adminOptions, setAdminOptions] = useState([]);
  const [batchId, setBatchId] = useState('');
  const [course, setCourse] = useState('');
  const [strength, setStrength] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      const response = await getBranches();
      const branchOptions = response.data.map(branch => ({
        value: branch.id,
        label: branch.name,
      }));
      setAdminOptions(branchOptions);
    } catch (error) {
      setError('Failed to fetch admins');
    }
  };

  useEffect(() => {
    if (editBatch) {
      //console.log(editBatch)
      setBatchId(editBatch.batch_id);
      setCourse(editBatch.course);
      setStrength(editBatch.strength);
      setAdmin(editBatch.user_id);
    } else {

      clearForm();
    }
  }, [editBatch, adminOptions]);

  const clearForm = () => {
    setAdmin('');
    setBatchId('');
    setCourse('');
    setStrength('');
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!admin) {
      setError('Please select an admin');
      return;
    }

    const batchData = {
      batch_id: batchId,
      user_id: admin,
      course,
      strength,
    };

    try {
      await onSubmit(batchData);
      clearForm();
    } catch (error) {
      setError('Failed to submit the form');
    }
  };

  return (
   <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
      <Typography variant="h5" align="center" gutterBottom color="green">
        {editBatch ? 'Edit Batch' : 'Add Batch'}
      </Typography>


      <FormControl fullWidth margin="normal">
        <InputLabel>Select Admin</InputLabel>
        <Select
          value={admin}
          label="Select Admin"
          onChange={(e) => setAdmin(e.target.value)}
          required
        >
          {adminOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Batch Id"
        value={batchId}
        onChange={(e) => setBatchId(e.target.value)}
        fullWidth
        margin="normal"
        required
      />

      <TextField
        label="Course"
        value={course}
        onChange={(e) => setCourse(e.target.value)}
        fullWidth
        margin="normal"
        required
      />

      <TextField
        label="Strength"
        value={strength}
        onChange={(e) => setStrength(e.target.value)}
        fullWidth
        margin="normal"
        required
      />

      <Box mt={3} display="flex" justifyContent="center">
        <Button variant="contained" color="success" type="submit" fullWidth onClick={handleSubmit}>
          {editBatch ? 'Update Batch' : 'Add Batch'}
        </Button>
      </Box>
    
      </Paper>
      </Container>
  );
};

export default AddBatchForm;
